import React from "react";
import {
    FaMobileAlt,
    FaApplePay,
    FaCloud,
} from "react-icons/fa";

import {
    MdSecurity,
    MdOutlinePsychology,
} from "react-icons/md";

import { HiBolt } from "react-icons/hi2";
import "./IOSFeaturesSection.css";

const IOSFeaturesSection = () => {
    const features = [
        {
            icon: <FaMobileAlt />,
            title: "Dynamic Island",
            desc: "Interactive iPhone experiences designed for modern iOS devices.",
        },
        {
            icon: <MdSecurity />,
            title: "Face ID Security",
            desc: "Secure authentication with Face ID & Apple Keychain integration.",
        },
        {
            icon: <FaApplePay />,
            title: "Apple Pay",
            desc: "Fast & secure payments directly inside your iOS application.",
        },
        {
            icon: <MdOutlinePsychology />,
            title: "AI Powered Apps",
            desc: "Smart recommendations and AI integrations for next-gen apps.",
        },
        {
            icon: <HiBolt />,
            title: "Lightning Fast",
            desc: "Optimized Swift performance for ultra-smooth user experience.",
        },
        {
            icon: <FaCloud />,
            title: "iCloud Sync",
            desc: "Real-time syncing across iPhone, iPad & Apple ecosystem.",
        },
    ];

    return (
        <>
            <section className="ios-features-section">

                {/* Blur Background */}
                <div className="ios-blur blur-1"></div>
                <div className="ios-blur blur-2"></div>

                <div className="ios-features-container">

                    {/* Heading */}
                    <div className="ios-heading">
                        <span>PREMIUM iOS FEATURES</span>

                        <h2>
                            Modern Features For
                            <span> Modern iPhone Apps</span>
                        </h2>

                        <p>
                            We create stunning iOS applications packed with
                            premium Apple ecosystem features & smooth animations.
                        </p>
                    </div>

                    {/* Features Grid */}
                    <div className="ios-grid">

                        {features.map((item, index) => (
                            <div
                                className="ios-card"
                                key={index}
                                style={{
                                    animationDelay: `${index * 0.15}s`,
                                }}
                            >

                                <div className="card-glow"></div>

                                <div className="feature-icon">
                                    {item.icon}
                                </div>

                                <h3>{item.title}</h3>

                                <p>{item.desc}</p>

                                <div className="card-line"></div>

                            </div>
                        ))}

                    </div>

                </div>
            </section>
        </>
    );
};

export default IOSFeaturesSection;